import RichText from './rich_text';
export default RichText;
